<img [src]="src" [alt]="alt" [class]="cls" (error)="onError()" (load)="onLoad($event)" class="object-cover w-full">